/**
 * Full-page loading spinner displayed as a Suspense fallback
 * while lazy-loaded route chunks are being fetched.
 */
import { Loader2 } from "lucide-react";

export default function LoadingSpinner() {
  return (
    <div className="flex min-h-screen items-center justify-center bg-cream dark:bg-slate-900">
      <div className="flex flex-col items-center gap-3">
        <Loader2 className="h-8 w-8 animate-spin text-red" />
        <span className="text-sm text-text-light dark:text-slate-400">
          Loading...
        </span>
      </div>
    </div>
  );
}
